import Client from "./models/Client";
import Notary from "./models/Notary";
import ApiService from "./ApiService";

class UserService {
  constructor() {
    this.user = "";
  }

  async initUser() {
    let user = await ApiService.get("/user/");
    this.user = this.defineUserType(user.data);

    return this.user;
  }

  defineUserType(user) {
    return user.is_client
      ? new Client(user)
      : new Notary({ ...user, ...user.notary });
  }
}
export default new UserService();
